export const visit = (vm, at) => {
vm(require("foundations-components/lang/it.lyaml"));
at({ "it": { "placeholder": "segnaposto" } });
};